<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">My Profile</h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            <a routerLink="/dashboard" class="d-inline-block position-relative">
                <i class="ri-home-8-line"></i>
                Dashboard
            </a>
        </li>
        <li class="breadcrumb-item position-relative">My Profile</li>
    </ol>
</div>

<!-- Loading -->
<div *ngIf="loading" class="profile-loading">
    <mat-spinner diameter="36"></mat-spinner>
</div>

<div *ngIf="!loading" class="row">

    <!-- ── LEFT: Profile Information ──────────────────────────────────────── -->
    <div class="col-lg-6 col-md-6 col-sm-12">
        <mat-card class="daxa-card profile-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>

                <!-- Avatar hero -->
                <div class="profile-hero">
                    <div class="avatar-circle">{{ getInitials() }}</div>
                    <div class="profile-hero-meta">
                        <h4>{{ profile?.first_name }} {{ profile?.last_name }}</h4>
                        <span class="hero-email">{{ profile?.email }}</span>
                        <div class="hero-badges">
                            <span class="badge-pill active">
                                <span class="badge-dot"></span> Active
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Stat tiles -->
                <div class="stat-grid">
                    <div class="stat-tile">
                        <span class="stat-value">{{ profile?.roles?.length || 0 }}</span>
                        <span class="stat-label">Roles</span>
                    </div>
                    <div class="stat-tile">
                        <span class="stat-value" [class.text-daxa]="profile?.is_superuser">
                            {{ profile?.is_superuser ? 'YES' : 'NO' }}
                        </span>
                        <span class="stat-label">Super User</span>
                    </div>
                    <div class="stat-tile">
                        <span class="stat-value text-success">Active</span>
                        <span class="stat-label">Status</span>
                    </div>
                </div>

                <!-- Info rows -->
                <ul class="info-list list-unstyled mt-0 mb-0 pl-0 pr-0">
                    <li>
                        <div class="info-icon-wrap blue">
                            <i class="ri-user-line"></i>
                        </div>
                        <div class="info-text">
                            <span class="info-key">FUll Name</span>
                            <span class="info-val">{{ profile?.first_name }} {{ profile?.last_name }}</span>
                        </div>
                    </li>
                    <!-- <li>
                        <div class="info-icon-wrap purple">
                            <i class="ri-user-3-line"></i>
                        </div>
                        <div class="info-text">
                            <span class="info-key">Last Name</span>
                            <span class="info-val">{{ profile?.last_name }}</span>
                        </div>
                    </li> -->
                    <li>
                        <div class="info-icon-wrap blue">
                            <i class="ri-mail-line"></i>
                        </div>
                        <div class="info-text">
                            <span class="info-key">Email</span>
                            <span class="info-val">{{ profile?.email }}</span>
                        </div>
                    </li>
                    <li>
                        <div class="info-icon-wrap green">
                            <i class="ri-shield-check-line"></i>
                        </div>
                        <div class="info-text">
                            <span class="info-key">Super User</span>
                            <span class="info-val" [class.text-daxa]="profile?.is_superuser">
                                {{ profile?.is_superuser ? 'YES' : 'NO' }}
                            </span>
                        </div>
                    </li>
                    <li>
                        <div class="info-icon-wrap orange">
                            <i class="ri-time-line"></i>
                        </div>
                        <div class="info-text">
                            <span class="info-key">Created At</span>
                            <span class="info-val">{{ profile?.created_at | date:'dd/MM/yyyy hh:mm a' }}</span>
                        </div>
                    </li>
                    <li>
                        <div class="info-icon-wrap orange">
                            <i class="ri-refresh-line"></i>
                        </div>
                        <div class="info-text">
                            <span class="info-key">Last Updated</span>
                            <span class="info-val">{{ profile?.updated_at | date:'dd/MM/yyyy hh:mm a' }}</span>
                        </div>
                    </li>
                    <li>
                        <div class="info-icon-wrap green">
                            <i class="ri-login-box-line"></i>
                        </div>
                        <div class="info-text">
                            <span class="info-key">Last Login</span>
                            <span class="info-val">{{ profile?.last_login | date:'dd/MM/yyyy hh:mm a' }}</span>
                        </div>
                    </li>
                </ul>

                <!-- Action buttons -->
                <div class="action-buttons">
                    <button mat-button class="btn-edit" (click)="openEditProfileDialog()">
                        <i class="ri-edit-line"></i> Edit Profile
                    </button>
                    <button mat-button class="btn-password" (click)="openChangePasswordDialog()">
                        <i class="ri-lock-password-line"></i> Change Password
                    </button>
                </div>

            </mat-card-content>
        </mat-card>
    </div>

    <!-- ── RIGHT: Role Information + Security ─────────────────────────────── -->
    <div class="col-lg-6 col-md-6 col-sm-12">

        <!-- Role Information card -->
        <mat-card class="daxa-card profile-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>

                <div class="right-card-title">
                    <i class="ri-shield-line icon-purple"></i>
                    <h5>Role Information</h5>
                </div>
                <p class="right-card-desc">Permissions and access levels assigned to this account.</p>

                <!-- Role chips -->
                <div class="role-chips-wrap" *ngIf="profile?.roles?.length; else noRoles">
                    <span class="role-chip" *ngFor="let role of profile?.roles">
                        <i class="ri-shield-check-line"></i>
                        {{ role.name }}
                    </span>
                </div>
                <ng-template #noRoles>
                    <p class="text-body mb-0">No roles assigned.</p>
                </ng-template>

                <!-- Permissions -->
                <!-- <ng-container *ngIf="hasPermissions()">
                    <div class="section-block">
                        <ng-container *ngFor="let role of profile?.roles">
                            <ng-container *ngIf="role.permissions?.length">
                                <ul class="perm-list list-unstyled mt-0 mb-0 pl-0">
                                    <li *ngFor="let perm of role.permissions">
                                        <i class="ri-checkbox-circle-line"></i>
                                        {{ perm.name }}
                                    </li>
                                </ul>
                            </ng-container>
                        </ng-container>
                    </div>
                </ng-container> -->

            </mat-card-content>
        </mat-card>

        <!-- Security card -->
        <mat-card class="daxa-card profile-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>

                <div class="right-card-title">
                    <i class="ri-lock-line icon-blue"></i>
                    <h5>Security</h5>
                </div>

                <div class="security-list">
                    <div class="security-row">
                        <div class="security-info">
                            <span class="sec-title">Password</span>
                            <span class="sec-sub">Last changed {{ profile?.updated_at | date:'dd/MM/yyyy' }}</span>
                        </div>
                        <button mat-button class="btn-update-pw" (click)="openChangePasswordDialog()">
                            Update
                        </button>
                    </div>
                    <!-- <div class="security-row">
                        <div class="security-info">
                            <span class="sec-title">Two-Factor Auth</span>
                            <span class="sec-sub">Adds extra security</span>
                        </div>
                        <span class="sec-badge warning">Disabled</span>
                    </div> -->
                    <div class="security-row last">
                        <div class="security-info">
                            <span class="sec-title">Session</span>
                            <span class="sec-sub">Current active session</span>
                        </div>
                        <span class="sec-badge success">Active</span>
                    </div>
                </div>

            </mat-card-content>
        </mat-card>

    </div>

</div>